import { getAccessTokenData } from '@/utils/getAccessTokenData.utils';
import { useIsMsnDashboardDisplay } from './useIsMsnDashboardDisplay.hooks';

export const useIsOrganizationInMsnOnly = () => {
  const accessTokenData = getAccessTokenData();
  const isMSNPortalVendor = useIsMsnDashboardDisplay();

  return accessTokenData?.organization?.createOrigin === 'msn-portal' && isMSNPortalVendor;
};
